import { classicShows } from '@/mocks/homeData';
import type { ClassicShow } from '@/pages/home/types';

const shows = classicShows as ClassicShow[];

export default function ClassicSection() {
  return (
    <section id="classic" className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto w-full max-w-6xl">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-sm text-accent-700">
              <i className="ri-award-line"></i>
              口碑经典
            </span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">值得一次补完的经典节目</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              这些系列节目更新稳定、口碑扎实，适合按集数顺序慢慢看完。评分与集数来自站内长期沉淀的观众反馈。
            </p>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground-500">
            <i className="ri-history-line"></i>
            长期更新 · 适合连续观看
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          {shows.map((show) => (
            <article
              key={show.title}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-100/60 transition-colors hover:border-accent-300"
            >
              <div className="relative h-40 w-full overflow-hidden">
                <img
                  src={show.cover}
                  alt={`${show.title} 节目封面`}
                  title={`${show.title} - 西瓜视频经典节目`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute right-2 top-2 inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs text-background-50">
                  <i className="ri-star-fill"></i>
                  {show.rating}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-lg text-foreground-950">{show.title}</h3>
                <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded bg-background-200 px-1.5 py-0.5">{show.genre}</span>
                  <span>{show.episodes}</span>
                </div>
                <p className="mt-3 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{show.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}